import clients from "../assets/get-clients.json";
import users from "../assets/get-users.json";

const formConfig = {};

const getShippingOrderFormEffective = () => {
  return Promise.resolve({data: formConfig});
}
const getUsers = () => {
  return Promise.resolve({data: users});
};

const getClients = () => {
  return Promise.resolve({data: clients});
};

const createClient = (clientData) => {
  const newClient = {...clientData, id: clients.length + 1};
  clients.push(newClient);
  return Promise.resolve({data: newClient});
};

const updateClient = (id, clientData) => {
  const index = clients.findIndex((c) => c.id === id);
  if (index !== -1) {
    clients[index] = {...clients[index], ...clientData};
    return Promise.resolve({data: clients[index]});
  }
  return Promise.reject(new Error("Client not found"));
};

const deleteClient = (id) => {
  const index = clients.findIndex((c) => c.id === id);
  if (index !== -1) {
    clients.splice(index, 1);
    return Promise.resolve({data: {}});
  }
  return Promise.reject(new Error("Client not found"));
};

const getShippingOrderFormConfig = (level, targetId) => {
  return Promise.resolve({data: formConfig});
};

const createShippingOrderFormConfig = (configData) => {
  // In a real scenario, you would update the form-config-1.json file.
  // For this mock, we'll just return the data.
  return Promise.resolve({data: configData});
};

const deleteShippingOrderFormConfig = (level, targetId) => {
  // In a real scenario, you would update the form-config-1.json file.
  // For this mock, we'll just return success.
  return Promise.resolve({data: {}});
};

const assignBranchToUser = (userId, branchId) => {
  const userIndex = users.findIndex(u => u.userId === userId);
  if (userIndex !== -1) {
    users[userIndex].branchId = branchId;
    return Promise.resolve({data: users[userIndex]});
  }
  return Promise.reject(new Error("User not found"));
};

const assignClientToUser = (userId, clientId) => {
  const userIndex = users.findIndex(u => u.userId === userId);
  if (userIndex !== -1) {
    users[userIndex].clientId = clientId;
    return Promise.resolve({data: users[userIndex]});
  }
  return Promise.reject(new Error("User not found"));
};

const getRecipients = () =>  {
  return Promise.resolve({data: [{
      code: 'code',
      name: 'Test',
      address1: 'TestAdd',
      fCityCode: 'TestC',
      fPostalCode: 'TestPost',
      telephone1: '5555555555'
    }]});
}

export {
  getShippingOrderFormEffective,
  getUsers,
  getClients,
  createClient,
  updateClient,
  deleteClient,
  getRecipients,
  getShippingOrderFormConfig,
  createShippingOrderFormConfig,
  deleteShippingOrderFormConfig,
  assignBranchToUser,
  assignClientToUser
};
